import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import { CurrentSubView } from '../../../models/enums'
import ParameterButton from './ParameterButton'

const LanguageButton = (): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const supported = useSelector((state: RootState) => state.localeReducer.supported)
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)
  const currentSubView = useSelector((state: RootState) => state.utilsReducer.currentSubView)

  /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */
  const handleClick = (): void => {
    dispatch(storeActions.utils.setCurrentSubView(currentSubView === CurrentSubView.languages ? CurrentSubView.none : CurrentSubView.languages))
  }

  return supported.length > 1 ? (
    <ParameterButton title={translation.common.lang} icon='lang' color={currentSubView === CurrentSubView.languages ? themeColors.secondary : '#A4A7AF'} onClick={handleClick} />
  ) : (
    <React.Fragment />
  )
}

export default LanguageButton
